import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
export var DataListContent = function DataListContent(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$id = _a.id,
      id = _a$id === void 0 ? '' : _a$id,
      _a$isHidden = _a.isHidden,
      isHidden = _a$isHidden === void 0 ? false : _a$isHidden,
      ariaLabel = _a['aria-label'],
      _a$hasNoPadding = _a.hasNoPadding,
      hasNoPadding = _a$hasNoPadding === void 0 ? false : _a$hasNoPadding,
      _a$rowid = _a.rowid,
      rowid = _a$rowid === void 0 ? '' : _a$rowid,
      props = __rest(_a, ["className", "children", "id", "isHidden", 'aria-label', "hasNoPadding", "rowid"]);

  return React.createElement("section", Object.assign({
    id: id,
    className: css(styles.dataListExpandableContent, className),
    hidden: isHidden,
    "aria-label": ariaLabel
  }, props), React.createElement("div", {
    className: css(styles.dataListExpandableContentBody, hasNoPadding && styles.modifiers.noPadding)
  }, children));
};